import React from "react"
import { Typography } from "../../../ui-library";

import './styles.scss';

const FraudNotice = () => {
  return <React.Fragment>
    <Typography className="flex text-center font-weight-bold">
      <span className="warning-text">FRAUD PREVENTION:</span> WE WILL NEVER ASK YOU TO UPDATE BANKING OR WIRING INFORMATION THROUGH EMAIL OR OVER THE PHONE.
    </Typography>
  </React.Fragment>
};

export default FraudNotice;
